<template>
  <div style="
      height: 100vh !important;
      background: linear-gradient(180deg, #ebedf7 70%, #ffffff 100%) !important;
    ">
    <div :class="getIsUploadsPage ? 'uploads-full-height' : ''">
      <template v-if="isShowHeader">
        <CommonHeader />
      </template>
      <router-view :class="getIsUploadsPage ? '' : 'full-height common-background-color-revamp'" />
      <Loading :active="isLoading" />
      <obj id="obj-data-appid" :value="user.loanAppId"></obj>
      <obj id="obj-data-cif" :value="user.cif"></obj>
      <obj id="obj-data-channel" :value="user.channel"></obj>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Loading: () => import("@/utils/Loading"),
    CommonHeader: () =>
      import("@/components/TemplateNewScreen/CommonHeader.vue"),
  },
  computed: {
    isShowHeader() {
      return (
        this.$route.name &&
        this.$route.name !== "NoAuthorized" &&
        this.$route.name !== "CallFromNext" &&
        this.$route.name !== "404" &&
        this.$route.name !== "LoginPage"
      );
    },
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
    user() {
      return this.$store.getters.getUserData;
    },
    getHeight() {
      // return window.innerHeight == 0 ? 650 : window.innerHeight;
      return window.innerHeight;
    },
    getIsUploadsPage() {
      return this.$route.name === "UploadPage";
    },
  },
  created() {
    // var h = window.innerHeight;
    // if (h == 0) h = 650;
    // var styleModalOpen = document.createElement("style");
    // styleModalOpen.type = "text/css";
    // styleModalOpen.innerHTML =
    //   ".modal-backdrop, .modal-content-custom ,.modal-open , .modal , .full-height { height: " +
    //   h +
    //   "px  !important ; } " +
    //   " .router-height{ height: " +
    //   (h - 45) +
    //   "px !important;}";
    // document.getElementsByTagName("head")[0].appendChild(styleModalOpen);
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
  },
};
</script>

<style>
@import "assets/styles/main.css";
</style>
<style>
.uploads-full-height {
  height: calc(100vh) !important;
}

.full-height {
  height: 100vh !important;
  overflow-y: scroll;
  padding: calc(13vh + 1rem) 1rem 1rem 1rem !important;
}
</style>
